module.exports = __webpack_public_path__ + "static/media/EbscoLogo.140bf8e2.svg";